import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type CreateP1DongleInstallationReminder = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
  accountId?: number;
};
/**
 * Endpoint to create a P1 dongle installation reminder
 *
 * @returns any Success
 */
export function createP1DongleInstallationReminder(
  { businessUnit, label, customerId, accountId }: CreateP1DongleInstallationReminder,
  requestConfig: ApiRequestConfig = {},
): Promise<any> {
  return request(
    {
      method: 'POST',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/dongle/installationReminder`,
      query: { accountId },
      errors: { 400: 'Bad Request', 500: 'Server Error' },
    },
    requestConfig,
  );
}
